<template>
  <span class="handicap-component">
    <span class="currenthandicap" :class="{hcpUp:hcpUp, hcpDown:hcpDown}">{{formattedHcp || ''}}</span>
  </span>
</template>

<script>
import hcpFormat from '@/library/hcpFormat'

export default {
  name: 'PopularParlayHcp',
  props: ['selection'],
  data () {
    return {
      hcpUp: false,
      hcpDown: false,
      clearInterval: 3,
      clearInt: null
    }
  },
  computed: {
    formattedHcp  () {
      return hcpFormat.formatHandicap(this.selection) || ''
    }
  },
  methods: {
    formatHcp () {
      return hcpFormat.formatHandicap(this.selection)
    },
    clearMarkings () {
      this.hcpUp = false
      this.hcpDown = false
    }
  },
  watch: {
    formattedHcp: {
      immediate: false,
      handler (newVal, oldVal) {
        // console.log('Watch oddsObj:', oldValObj, '=>', newValObj)
        clearTimeout(this.clearInt)
        this.clearInt = setTimeout(() => {
          this.clearMarkings()
        }, this.clearInterval * 1000)
        //
        let hcpUp = false
        let hcpDown = false
        if (newVal && oldVal && newVal !== oldVal) {
          let newValN = Number(newVal)
          let oldValN = Number(oldVal)
          hcpUp = newValN > oldValN
          hcpDown = newValN < oldValN
        }
        this.hcpUp = hcpUp
        this.hcpDown = hcpDown
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/css/config"
.handicap-component
  .currenthandicap
    &.hcpUp
      &:after
        background: transparent
        content: url(icons-path'/price-up-small.svg');
        line-height: 0;
        top: 4px;
        width: 10px;
        height: 10px;
    &.hcpDown
      &:after
        background: transparent
        content: url(icons-path'/price-down-small.svg');
        line-height: 0;
        top: 4px;
        width: 10px;
        height: 10px;
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/popularParlays/PopularParlayHcp.vue